import React from "react";
import { Controller, useFormContext } from "react-hook-form";

function FormCheck({
  name,
  label,
  errors,
  errormessage,
  defaultValue,
  ...others
}: any) {
  const { control } = useFormContext();

  return (
    <div className="flex items-center gap-2">
      <Controller
        name={name ? name : ""}
        control={control}
        defaultValue={defaultValue ? defaultValue : false}
        render={({ field: { onChange, value } }) => (
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              onChange={onChange}
              checked={value}
              className="sr-only peer"
              {...others}
            />
            <div className="w-10 h-5 bg-slate-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-primary/20 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-slate-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-primary"></div>
          </label>
        )}
      />
      <span className="text-sm font-medium text-slate-700">{label || "Label"}</span>
      {errors && (
        <span className="text-xs text-red-500">{errormessage || "Error"}</span>
      )}
    </div>
  );
}

export default FormCheck;
